









import { Vue, Component, Prop } from 'vue-property-decorator'
import { format } from 'quasar'

@Component
export default class AttendeeSessionDurationFormat extends Vue {
  pad = format.pad

  @Prop()
  readonly miliseconds!: number | undefined

  get seconds () {
    return Math.floor((this.miliseconds || 0) / 1000)
  }

  get minutes () {
    return Math.floor(this.seconds / 60)
  }

  get hours () {
    return Math.floor(this.minutes / 60)
  }
}
